import { Scene } from "contexts/Scenes/types";

export default function isSceneProcessing(scene: Scene): boolean {
	return scene.pipelineStatusSummary === "ongoing";
}
